import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function UrunlerPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Brilliant Perde - Plise',
      description: 'Brilliant\'in modern ve şık tasarımıyla mekanlarınıza zarafet katan plise perdeler',
      image: 'https://public.readdy.ai/ai/img_res/00459f012b8d4aca9611f37990847249.jpg',
      features: ['Işık kontrolü', 'Kolay temizlik', 'Uzun ömürlü'],
      link: '/urunler/plise-perde',
      brand: 'Brilliant'
    },
    {
      id: 2,
      name: 'Brilliant Perde - Jaluzi',
      description: 'Brilliant\'in pratik kullanım ve modern görünümüyle ofis ve evler için ideal jaluzileri',
      image: 'https://readdy.ai/api/search-image?query=Brilliant%20brand%20contemporary%20venetian%20blinds%20sophisticated%20office%20space%20clean%20lines%20minimalist%20design%20horizontal%20slats%20warm%20wood%20tones%20white%20walls%20soft%20natural%20light%20professional%20product%20photography&width=600&height=700&seq=brilliant2&orientation=portrait',
      features: ['Işık ayarı', 'Dayanıklı yapı', 'Kolay montaj'],
      link: '/urunler/jaluzi-perde',
      brand: 'Brilliant'
    },
    {
      id: 3,
      name: 'Brilliant Perde - Tül & Fon',
      description: 'Brilliant\'in zarif ve hafif dokusuyla mekanlarınıza romantik bir hava katan tül perdeleri',
      image: 'https://readdy.ai/api/search-image?query=Brilliant%20brand%20luxurious%20sheer%20tulle%20curtains%20flowing%20elegantly%20bright%20modern%20living%20room%20soft%20diffused%20natural%20light%20ethereal%20atmosphere%20clean%20white%20walls%20minimalist%20furniture%20professional%20product%20photography&width=600&height=700&seq=brilliant3&orientation=portrait',
      features: ['Hafif doku', 'Işık geçirgen', 'Zarif görünüm'],
      link: '/urunler/tul-perde',
      brand: 'Brilliant'
    },
    {
      id: 4,
      name: 'Brilliant Perde - Zebra',
      description: 'Brilliant\'in iki farklı kumaş şeridiyle ışık kontrolünde maksimum esneklik sağlayan zebra perdeleri',
      image: 'https://readdy.ai/api/search-image?query=Brilliant%20brand%20modern%20zebra%20roller%20blinds%20alternating%20fabric%20stripes%20contemporary%20bedroom%20clean%20minimalist%20design%20soft%20natural%20lighting%20neutral%20color%20palette%20white%20walls%20professional%20product%20photography&width=600&height=700&seq=brilliant4&orientation=portrait',
      features: ['Çift katmanlı', 'Işık kontrolü', 'Modern tasarım'],
      link: '/urunler/zebra-perde',
      brand: 'Brilliant'
    },
    {
      id: 5,
      name: 'Brilliant Perde - Stor',
      description: 'Brilliant\'in minimalist tasarımıyla her türlü dekora uyum sağlayan stor perdeleri',
      image: 'https://readdy.ai/api/search-image?query=Brilliant%20brand%20elegant%20roller%20blinds%20modern%20minimalist%20interior%20clean%20white%20walls%20soft%20natural%20lighting%20smooth%20fabric%20texture%20warm%20neutral%20tones%20contemporary%20design%20aesthetic%20professional%20product%20photography&width=600&height=700&seq=brilliant5&orientation=portrait',
      features: ['Kompakt yapı', 'Kolay kullanım', 'Geniş renk seçeneği'],
      link: '/urunler/stor-perde',
      brand: 'Brilliant'
    },
    {
      id: 6,
      name: 'Brilliant Perde - Fon',
      description: 'Brilliant\'in kalın dokusuyla ışık ve ses yalıtımı sağlayan fon perdeleri',
      image: 'https://readdy.ai/api/search-image?query=Brilliant%20brand%20luxurious%20blackout%20curtains%20rich%20fabric%20draped%20elegantly%20sophisticated%20bedroom%20soft%20ambient%20lighting%20minimalist%20design%20deep%20neutral%20tones%20clean%20white%20walls%20professional%20product%20photography&width=600&height=700&seq=brilliant6&orientation=portrait',
      features: ['Işık yalıtımı', 'Ses yalıtımı', 'Kaliteli kumaş'],
      link: '/urunler/fon-perde',
      brand: 'Brilliant'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/urunler" className="text-sm font-medium text-amber-600 transition-colors whitespace-nowrap">Ürünler</Link>
              <Link to="/hali" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Halı Satışı</Link>
              <Link to="/ev-tekstili" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ev Tekstili</Link>
              <Link to="/hakkimizda" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/iletisim" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">İletişim</Link>
            </div>

            <Link to="/iletisim" className="hidden lg:block bg-amber-700 hover:bg-amber-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              Teklif Al
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6">Ürünlerimiz</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Eviniz ve ofisiniz için geniş perde çeşitlerimizi keşfedin. Her mekan için ideal çözümler sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {products.map((product) => (
              <Link 
                key={product.id}
                to={product.link}
                className="group cursor-pointer"
              >
                <div className="bg-gray-50 rounded-3xl overflow-hidden transition-all hover:shadow-2xl hover:scale-105">
                  <div className="w-full h-96 relative">
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-bold text-amber-700">{product.brand}</span>
                    </div>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.name}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{product.description}</p>
                    <div className="space-y-2 mb-6">
                      {product.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2">
                          <i className="ri-check-line text-amber-600"></i>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                    <div className="flex items-center gap-2 text-amber-700 font-medium group-hover:gap-4 transition-all">
                      <span>Detaylı İncele</span>
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Ücretsiz Keşif ve Ölçüm</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Uzman ekibimiz size en uygun çözümleri sunmak için hazır. Hemen iletişime geçin.
          </p>
          <Link to="/iletisim" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            Teklif Al →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}